module.exports = __webpack_public_path__ + "img/云存储5.ebe9f907.jpg";